import React, { useMemo, useState } from 'react';
import { loans, runPeriod, staff } from '../data/commissionRun';
import { computeLoanResult } from '../utils/commission';
import { BrandHeader } from '../components/BrandHeader';
import { PersonPayouts, type PersonRow } from '../components/PersonPayouts';
import { RunSummary } from '../components/RunSummary';
type OverrideMap = Record<string, Record<string, number>>;
export function CommissionRun() {
  const [overrides, setOverrides] = useState<OverrideMap>({});
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [query, setQuery] = useState('');
  const results = useMemo(() => loans.map(loan => computeLoanResult(loan, staff, overrides[loan.id] ?? {})), [overrides]);
  const rows: PersonRow[] = useMemo(() => {
    const byStaff = staff.map(member => {
      const files = results.flatMap(result => {
        const payout = result.payouts.find(p => p.staff.id === member.id);
        if (!payout) return [];
        return [{
          result,
          entitledBps: payout.entitledBps,
          baselineBps: payout.baselineBps,
          isOverridden: payout.isOverridden,
          shareOfFullComp: payout.shareOfFullComp,
          payoutBps: payout.payoutBps,
          payoutDollars: payout.payoutDollars
        }];
      });
      return {
        staff: member,
        files,
        total: files.reduce((sum, file) => sum + file.payoutDollars, 0)
      };
    });
    return byStaff.filter(row => row.files.length > 0).sort((a, b) => b.total - a.total);
  }, [results]);
  const payoutTotal = rows.reduce((sum, row) => sum + row.total, 0);
  const visibleRows = useMemo(() => {
    const term = query.trim().toLowerCase();
    if (term.length === 0) return rows;
    return rows.filter(row => row.staff.name.toLowerCase().includes(term));
  }, [rows, query]);
  const handleOverride = (loanId: string, staffId: string, value: number | undefined) => {
    setOverrides(current => {
      const forLoan = {
        ...(current[loanId] ?? {})
      };
      if (value === undefined) {
        delete forLoan[staffId];
      } else {
        forLoan[staffId] = value;
      }
      return {
        ...current,
        [loanId]: forLoan
      };
    });
  };
  return <div className="min-h-full w-full bg-canvas font-sans text-ink" data-id="element-124" data-mp="3nh2t8y6xehpz">
      <BrandHeader periodLabel={runPeriod.label} data-id="element-125" data-mp="3neyo6cxajco4" />
      <RunSummary periodLabel={runPeriod.label} tierBasisLabel={runPeriod.tierBasisLabel} payoutTotal={payoutTotal} loanCount={results.length} peopleCount={rows.length} data-id="element-126" data-mp="3ii88hqpeej38" />

      <main className="mx-auto max-w-[1600px] px-6 py-6" data-id="element-127" data-mp="39i31hho49mpl">
        <PersonPayouts rows={visibleRows} expanded={expanded} query={query} onQueryChange={setQuery} onToggle={staffId => setExpanded(current => ({
        ...current,
        [staffId]: !current[staffId]
      }))} onOverride={handleOverride} data-id="element-128" data-mp="34ignh60gs2fq" />
      </main>
    </div>;
}